var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled === true},domProps:{"checked":_vm.checked === true}})
}
var staticRenderFns = []

export { render, staticRenderFns }